/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Capture_Hint_PhoneInputs */

const en_us2_body_assessment_capture_hint_phone = /** @type {(inputs: Body_Assessment_Capture_Hint_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone upright, resting between the floor and navel height. Never from above.`)
};

const pt_br2_body_assessment_capture_hint_phone = /** @type {(inputs: Body_Assessment_Capture_Hint_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celular em pé, apoiado entre o chão e a altura do umbigo. Nunca de cima.`)
};

const es_419_body_assessment_capture_hint_phone = /** @type {(inputs: Body_Assessment_Capture_Hint_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teléfono en vertical, apoyado entre el suelo y la altura del ombligo. Nunca desde arriba.`)
};

const pt_pt2_body_assessment_capture_hint_phone = /** @type {(inputs: Body_Assessment_Capture_Hint_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telemóvel na vertical, apoiado entre o chão e a altura do umbigo. Nunca de cima.`)
};

const fr_fr2_body_assessment_capture_hint_phone = /** @type {(inputs: Body_Assessment_Capture_Hint_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléphone debout, posé entre le sol et la hauteur du nombril. Jamais en plongée.`)
};

const de_de2_body_assessment_capture_hint_phone = /** @type {(inputs: Body_Assessment_Capture_Hint_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handy aufrecht, abgestellt zwischen Boden und Nabelhöhe. Nie von oben.`)
};

const it_it2_body_assessment_capture_hint_phone = /** @type {(inputs: Body_Assessment_Capture_Hint_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefono in verticale, appoggiato tra il pavimento e l'altezza dell'ombelico. Mai dall'alto.`)
};

/**
* | output |
* | --- |
* | "Phone upright, resting between the floor and navel height. Never from above." |
*
* @param {Body_Assessment_Capture_Hint_PhoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_capture_hint_phone = /** @type {((inputs?: Body_Assessment_Capture_Hint_PhoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Capture_Hint_PhoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_capture_hint_phone(inputs)
	if (locale === "es-419") return es_419_body_assessment_capture_hint_phone(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_capture_hint_phone(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_capture_hint_phone(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_capture_hint_phone(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_capture_hint_phone(inputs)
	return en_us2_body_assessment_capture_hint_phone(inputs)
});
export { body_assessment_capture_hint_phone as "body-assessment.capture_hint_phone" }